import React from "react";

export function OrbitMotif({ className = "", color = "#9ACD32", opacity = 0.15 }) {
  return (
    <svg
      className={`pointer-events-none ${className}`}
      viewBox="0 0 800 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <ellipse
        cx="400"
        cy="400"
        rx="380"
        ry="120"
        stroke={color}
        strokeWidth="1.5"
        opacity={opacity}
        transform="rotate(-15 400 400)"
      />
      <ellipse
        cx="400"
        cy="400"
        rx="300"
        ry="220"
        stroke={color}
        strokeWidth="1"
        opacity={opacity * 0.7}
        transform="rotate(25 400 400)"
      />
      <ellipse
        cx="400"
        cy="400"
        rx="200"
        ry="320"
        stroke={color}
        strokeWidth="1"
        opacity={opacity * 0.5}
        transform="rotate(55 400 400)"
      />
      <circle cx="400" cy="400" r="4" fill={color} opacity={opacity * 3} />
    </svg>
  );
}
